export enum CurrencyEnum {
  US = 'USD',
}
export interface CurrencyMapI {
  [key: string]: string;
}

/**
 * Business / display timezone — Central (America/Chicago).
 *
 * Frontend mirror of the backend canonical constant in
 * `@bodyanalytics/common-api` (`libs/back/api/common-api/src/lib/constants/timezone.ts`);
 * the two Nx project graphs cannot import across each other, so the value is
 * duplicated and MUST stay equal — a value-pinning test in each lib guards drift.
 *
 * This is the CUSTOMER/display zone, never the server zone (the API host runs
 * Eastern). Always pass it explicitly to date-fns-tz conversions; never format a
 * stored instant from the host clock.
 */
export const DEFAULT_TIMEZONE = 'America/Chicago';

/**
 * Standard admin form contract (founder decision 2026-07-19): every create/edit
 * form exposes `mode: FormModeT`, `initialValue`, `(save)` and `(cancel)`.
 * Shared here — never re-declared per feature lib.
 */
export type FormModeT = 'create' | 'edit';
